import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import nirfPic from '../../../src/assets/images/Eng_WL.png';
import chairPic from '../../../src/assets/images/feature_chairs.jpg';
import cutoffsPic from "../../../src/assets/images/feature_cutoffs.jpg";
import clockPic  from "../../../src/assets/images/feature_clock_1.jpg";
import schedulePic  from "../../../src/assets/images/feature_schedules.jpg";
import forumPic  from "../../../src/assets/images/feature_forum_3.jpg";
import predictorPic from '../../../src/assets/images/Prediction Flag.svg'; 

import { useNavigate } from "react-router-dom";

export function Features() {
  const features = [
    {
      icon: clockPic,
      title: "Exam Schedules and Notices",
      description: "Never miss a deadline! Stay updated with MHT CET and engineering entrance exam schedules, notifications, and important dates.",
      navigatesite: "cetzone",
      tabid: 0
    },

    {
      icon: nirfPic,
      title: "NIRF Rankings",
      description: "Explore the official National Institutional Ranking Framework (NIRF) to compare top engineering colleges across India.",
      navigatesite: "capzone",
      tabid: 0
    },
    {
      icon: schedulePic,
      title: "CAP Rounds Schedules and Notices",
      description: "Track the latest CAP round schedules, result announcements, and updates for centralized admissions.",
      navigatesite: "capzone",
      tabid: 1
    },
    {
      icon: chairPic,
      title: "Seat Availability Insights",
      description: "Get up-to-date seat vacancy info to make informed decisions during the CAP rounds and college selection process.",
      navigatesite: "capzone",
      tabid: 2
    },
    {
      icon: cutoffsPic,
      title: "Cutoff Rankings",
      description: "Access detailed college-wise cutoff data from previous years to estimate your admission chances and plan strategically.",
      navigatesite: "capzone",
      tabid: 3
    },
    // {
    //   icon: forumPic,
    //   title: "Community Forum",
    //   description: "Offering detailed college cutoffs, empowering students to strategize and maximize their chances of admission.",
    //   navigatesite: "community",
    //   tabid: 0
    // },
    {
      icon: predictorPic,
      title: "Seat Predictor",
      description: "Predict colleges and branches you are likely to secure based on your rank and previous years' admission trends.",
      navigatesite: "prediction",
      tabid: 0
    },
  ]
  const FeatureCard = ({ title, description, icon, navigatesite, tabid }) => {
    const navigate = useNavigate();
    const handleNavigate = () => {
      navigate(`/${navigatesite}`, { 
        state: { 
          tabId: tabid, 
          title: title, 
          description: description 
        } 
      });
    };
    return (
      <div className="flex flex-col items-center text-center bg-white rounded-xl sm:rounded-2xl shadow-md p-4 sm:p-5 md:p-6 transition hover:shadow-xl hover:-translate-y-1">
        <img 
          src={icon} 
          alt={title} 
          className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 object-contain mb-2 sm:mb-3" 
        />
        <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-primary-700 mb-2 sm:mb-3">
          {title}
        </h3>
        <p className="text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4 px-2 sm:px-0">
          {description}
        </p>
        <button 
          onClick={handleNavigate}  
          className="mt-auto px-4 sm:px-5 py-2 sm:py-2.5 h-auto w-fit
                     bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                     border-2 border-primary-900 rounded-full 
                     text-xs sm:text-sm font-bold tracking-wide normal-case 
                     shadow-md transition duration-200"
        >
          Take a look
        </button>
      </div>
    );
  };
  
  return (
    <div className="w-full px-4 sm:px-6 md:px-8 py-6 sm:py-8 md:py-10">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary-900 mb-6 sm:mb-8 md:mb-10">
          What You'll Find on College Avenue
        </h2>
        
        {/* Mobile Carousel - Only visible on mobile (< 640px) */}
        <div className="features-mobile-carousel-container w-full">
          <div className="w-full relative" style={{ minHeight: '300px' }}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={20}
              slidesPerView={1}
              slidesPerGroup={1}
              navigation={true}
              pagination={{ 
                clickable: true,
                dynamicBullets: true
              }}
              watchOverflow={true}
              className="features-carousel-mobile"
              style={{ width: '100%', height: '100%' }}
            >
              {features.map((feature, index) => (
                <SwiperSlide key={index} style={{ height: 'auto' }}>
                  <div className="w-full h-full px-2 pb-2">
                    <FeatureCard 
                      title={feature.title} 
                      description={feature.description} 
                      icon={feature.icon} 
                      navigatesite={feature.navigatesite} 
                      tabid={feature.tabid}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* Desktop Grid - Hidden on mobile (>= 640px) */}
        <div className="features-desktop-grid-container">
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index} 
              title={feature.title} 
              description={feature.description} 
              icon={feature.icon} 
              navigatesite={feature.navigatesite} 
              tabid={feature.tabid}
            />
          ))}
          </div>
        </div>
      </div>

      {/* Custom Styles for Mobile Carousel and Responsive Display */}
      <style>{`
        /* Mobile Carousel - Show on mobile, hide on desktop */
        .features-mobile-carousel-container {
          display: block;
        }
        @media (min-width: 640px) {
          .features-mobile-carousel-container {
            display: none !important;
          }
        }
        
        /* Desktop Grid - Hide on mobile, show on desktop */
        .features-desktop-grid-container {
          display: none;
        }
        @media (min-width: 640px) {
          .features-desktop-grid-container {
            display: block !important;
          }
        }
        
        .features-carousel-mobile {
          width: 100% !important;
          max-width: 100% !important;
          padding-bottom: 3.5rem !important;
          overflow: hidden !important;
        }
        .features-carousel-mobile .swiper-wrapper {
          display: flex !important;
          align-items: stretch !important;
        }
        .features-carousel-mobile .swiper-slide {
          height: auto !important;
          box-sizing: border-box !important;
          flex-shrink: 0 !important;
          display: flex !important;
        }
        .features-carousel-mobile .swiper-slide > div {
          width: 100% !important;
          display: flex !important;
        }
        .features-carousel-mobile .swiper-button-next,
        .features-carousel-mobile .swiper-button-prev {
          color: #19BA92 !important;
          background-color: white !important;
          width: 2.5rem !important;
          height: 2.5rem !important;
          border-radius: 50% !important;
          box-shadow: 0 2px 8px rgba(25, 186, 146, 0.3) !important;
          transition: all 0.3s ease !important;
          z-index: 10 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .features-carousel-mobile .swiper-button-next::after,
        .features-carousel-mobile .swiper-button-prev::after {
          font-size: 1rem !important;
          font-weight: bold !important;
        }
        .features-carousel-mobile .swiper-button-next:hover,
        .features-carousel-mobile .swiper-button-prev:hover {
          background-color: #19BA92 !important;
          color: white !important;
          transform: scale(1.1) !important;
        }
        .features-carousel-mobile .swiper-button-disabled {
          opacity: 0.35 !important;
          cursor: not-allowed !important;
        }
        .features-carousel-mobile .swiper-pagination {
          bottom: 0.5rem !important;
          position: absolute !important;
          width: 100% !important;
        }
        .features-carousel-mobile .swiper-pagination-bullet {
          background-color: #19BA92 !important;
          opacity: 0.5 !important;
          width: 0.5rem !important;
          height: 0.5rem !important;
          transition: all 0.3s ease !important;
          margin: 0 0.25rem !important;
        }
        .features-carousel-mobile .swiper-pagination-bullet-active {
          opacity: 1 !important;
          width: 1.5rem !important;
          border-radius: 0.25rem !important;
          background-color: #19BA92 !important;
        }
      `}</style>
    </div>
  );
}

